<template>
  <button
    v-if="!to"
    v-bind="$attrs"
    :disabled="props.disabled"
    class="c-button"
    :class="[{ active: activeState }, classname]"
    @click="emits('click')"
    :title="props.title"
  >
    <country-flag v-if="props.flag" :country="props.flag" class="c-icon-flag"></country-flag>
    <IconBase v-else :color="props.color" :customClass="name ? 'mr-2' : ''" :name="icon" width="18" height="18" />
    {{ name }}
  </button>
  <RouterLink v-if="to" :to="to" class="c-button" :disabled="props.disabled" :class="classname" :title="props.title">
    <country-flag v-if="props.flag" :country="props.flag" class="c-icon-flag"></country-flag>
    <IconBase v-else :color="props.color" :customClass="name ? 'mr-2' : ''" :name="icon" width="18" height="18" />
    {{ name }}
  </RouterLink>
</template>
<script lang="ts" setup>
import IconBase from '@/components/icons/IconBase.vue'
import { ButtonProps } from '@/types/button/Button.types'
import { PropType } from 'vue'
const emits = defineEmits(['click'])
const props = defineProps({
  flag: {
    type: String
  },
  name: {
    type: String as PropType<ButtonProps['name'] | null>
  },
  icon: {
    type: String as PropType<ButtonProps['icon']>,
    default: ''
  },
  classname: {
    type: String,
    default: ''
  },
  to: {
    type: String,
    default: ''
  },
  color: {
    type: String
  },
  activeState: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  title: {
    type: String
  }
})
</script>
